import React, { useContext } from 'react';
import Panel from './containers/Panel/Panel';
import { MuiThemeProvider } from '@material-ui/core';
import { theme } from './styles/styles';
import './utils/i18n';
import { Route, Switch } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Login from './containers/Login/Login';
import { withProviders } from './contexts/withProviders';
import { SessionProvider, SessionContext } from './contexts/session/SessionContext';
import { PanelProvider } from './contexts/panel/PanelContext';
import { TableStateProvider } from './contexts/tableState/TableStateContext';
import { EPaths } from './types/enums/EPaths';
import { SnackMessageProvider } from './contexts/snackMessage/SnackMessageContext';
import SnackMessage from './components/SnackMessage/SnackMessage';
import SessionEndDialog from './components/SessionEndDialog/SessionEndDialog';
import PasswordReset from './containers/Login/PasswordReset';
import ExpiredPasswordReset from './containers/Login/ExpiredPasswordReset';
import EmailVerification from './containers/Registration/EmailVerification';
import PaymentResult from './containers/PaymentResult/PaymentResult';
import FiltersProvider from './contexts/filter/FiltersProvider';
import NonAppEmailVerification from './containers/Registration/NonAppEmailVerification';

function App() {
  const { isTokenRead } = useContext(SessionContext);

  return (
    <MuiThemeProvider theme={theme}>
      {isTokenRead && (
        <Router>
          <SessionEndDialog />
          <Switch>
            <Route path={EPaths.Login} exact component={Login} />
            <Route path={EPaths.PasswordReset} exact component={PasswordReset} />
            <Route path={EPaths.ExpiredPasswordReset} exact component={ExpiredPasswordReset} />
            <Route path={EPaths.EmailVerification} exact component={EmailVerification} />
            <Route path={EPaths.CompleteRegistration} exact component={NonAppEmailVerification} />
            <Route path={EPaths.PaymentResult} exact component={PaymentResult} />
            <Panel />
          </Switch>
        </Router>
      )}
      <SnackMessage />
    </MuiThemeProvider>
  );
}

export default withProviders(App, [
  SessionProvider,
  PanelProvider,
  FiltersProvider,
  TableStateProvider,
  SnackMessageProvider,
]);
